export default __webpack_public_path__ + "static/media/Bottles_Jera.4046af0b.jpg";